/** Preserve locale and every active filter while returning sorting to page one. */
export function collectionSortURL(currentURL, sortValue) {
  const url = new URL(currentURL);
  url.searchParams.set('sort_by', sortValue);
  url.searchParams.delete('page');
  url.searchParams.delete('section_id');
  url.hash = '';
  return url;
}

const pendingSorts = new Map();

// Delegation survives section morphs and keeps the ordinary GET form as fallback.
async function sortCollection(event) {
  if (!(event.target instanceof Element)) return;
  const form = event.target.closest('form[data-collection-sort]');
  if (!(form instanceof HTMLFormElement)) return;
  if (event.type === 'change' && event.target.getAttribute('name') !== 'sort_by') return;

  const section = form.closest('.shopify-section');
  const facets = section?.querySelector('facets-form-component');
  if (!facets || typeof facets.updateFiltersByURL !== 'function') {
    if (event.type === 'change') form.requestSubmit();
    return;
  }

  event.preventDefault();
  const select = form.querySelector('select[name="sort_by"]');
  if (!(select instanceof HTMLSelectElement)) return;
  const url = collectionSortURL(window.location.href, select.value);
  const request = {};
  pendingSorts.set(section.id, request);
  form.setAttribute('aria-busy', 'true');

  try {
    await facets.updateFiltersByURL(url.href);
    // Restore keyboard focus only if the user has not moved to another control.
    if (pendingSorts.get(section.id) === request && window.location.href === url.href &&
        (document.activeElement === select || document.activeElement === document.body)) {
      document.getElementById(select.id)?.focus({ preventScroll: true });
    }
  } catch {
    // A failed section request falls back to the same filtered, localized page.
    if (pendingSorts.get(section.id) === request && window.location.href === url.href) {
      window.location.assign(url.href);
    }
  } finally {
    if (pendingSorts.get(section.id) === request) {
      pendingSorts.delete(section.id);
      document.getElementById(section.id)?.querySelector('[data-collection-sort]')?.removeAttribute('aria-busy');
    }
  }
}

document.addEventListener('change', sortCollection);
document.addEventListener('submit', sortCollection);
